export default __webpack_public_path__ + "static/media/GoogleLogo.05ac0ebe.ico";